import { snakeCase } from 'lodash';
import { PlatformType } from '../../../../types/platformType';
import { BASE_PARAMS } from './constants';

export const createBigQueryEvent =
    (type, params) =>
    ({ collection = {}, sourceInfo = {} } = {}) => ({
        type,
        collection: {
            id: collection.id,
            original_collection_id: collection.originalId,
            name: collection.name,
            type: collection.ownerType,
        },
        page: {
            element: {
                metadata: collection.description,
            },
        },
        event_source: snakeCase(sourceInfo.name),
        user: { id: sourceInfo.userId },
        platform: sourceInfo.isTouch ? PlatformType.MOBILE_WEB : PlatformType.WEB,
        ...BASE_PARAMS,
        ...params,
    });
